import { BidiModule } from "@angular/cdk/bidi";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { NzI18nModule } from "ng-zorro-antd/i18n";
import { UiAccessibilityModule } from "../accessibility/accessibility.module";
import { UiIconModule } from "../icon/icon.module";
import { UiTimePickerPanelComponent } from "./components/time-picker-panel/time-picker-panel.component";
import { UiTimePickerComponent } from "./time-picker.component";

@NgModule({
  imports: [CommonModule, FormsModule, BidiModule, OverlayModule, NzOutletModule, NzI18nModule, UiIconModule, UiAccessibilityModule],
  declarations: [UiTimePickerComponent, UiTimePickerPanelComponent],
  exports: [UiTimePickerComponent, UiTimePickerPanelComponent],
})
export class UiTimePickerModule {}
